import { render, staticRenderFns } from "./wydz.vue?vue&type=template&id=02352358&scoped=true&"
import script from "./wydz.vue?vue&type=script&lang=js&"
export * from "./wydz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02352358",
  null
  
)

export default component.exports